<div class="chat-header">
  <div class="peer-meta">
    <div class="avatar peer-avatar">
      <app-user-avatar [name]="name()" [avatarUrl]="avatarUrl()" />
    </div>
    <div>
      <strong>
        {{ name() }}
        @if (country()) {
          <span
            class="country-flag-wrapper"
            [attr.data-country]="countryName(country())"
          >
            <app-flag
              [countryCode]="country()"
              [countryName]="countryName(country())"
              [size]="20"
            />
          </span>
        }
      </strong>
    </div>
  </div>
  <div class="header-actions">
    @if (blockConfirmation()) {
      <div class="block-confirm-row">
        <span>Block this person?</span>
        <button type="button" class="confirm-block-btn" (click)="block.emit()">
          Block
        </button>
        <button
          type="button"
          class="cancel-block-btn"
          (click)="cancelBlock.emit()"
        >
          Cancel
        </button>
      </div>
    } @else {
      <button type="button" class="action-btn block-btn" (click)="block.emit()">
        Block
      </button>
    }
  </div>
</div>

@if (sharedInterests().length > 0) {
  <section class="shared-interest-banner" aria-label="Shared interests">
    <span>Today</span>
    <strong>You both like</strong>
    <div>
      @for (interest of sharedInterests(); track interest) {
        <b>{{ interest }}</b>
      }
    </div>
  </section>
}
